// Brandprofil for digitalbox.dk — whitelabel af hentpost.
//
// Samme funktioner, egen identitet. Felter der stadig peger paa hentpost eller
// CapexConnect er markeret; de afventer afklaring af Digital Post-registrering
// og supportaftale.

const domain = 'digitalbox.dk';
// Hejst, saa footerkolonnen og supportEmail ikke kan komme til at pege
// hvert sit sted naar adressen skiftes.
const supportEmail = 'support@capexconnect.dk';

module.exports = {
    key: 'digitalbox',
    name: 'DigitalBox',
    // Den anden instans, selskaber kan spejles med. Navnet hoerer i
    // brand-laget: staar det i en komponent, laekker det til det andet brand.
    partner_navn: 'HentPost',
    domain,
    // Bilagsindbakkens domaene. Ikke digitalbox.dk: dets MX peger paa
    // selskabets egen Outlook. Skal matche mail_domain i backend/brand.py.
    mailDomain: 'app.digitalbox.dk',

    // Brandets egen adminkonto. Bruges kun til at vise handlinger, som
    // backenden alligevel forbeholder netop den konto — se
    // _er_brandets_admin i server.py. Frontenden afgoer intet selv.
    // Skal matche admin_email i backend/brand.py — den styrer baade
    // admin-menuen her og identitetstjekket paa serveren.
    adminEmail: 'info@digitalbox.dk',

    wordmark: { lead: 'Digital', tail: 'Box' },

    // Indbakken som i Figma-designet (docs/design/digitalbox/app-mock): lys
    // sidebar med selskaberne, beskedliste og detaljevisning side om side.
    // Hentpost har den foldbare liste og den moerke sidebar.
    appDesign: 'tre-kolonner',

    title: 'DigitalBox – Digital post direkte i indbakken',
    description: 'DigitalBox – Modtag al din virksomheds digitale post og bilag ét sted. Automatisk videresendelse fra Virk og e-Boks, plus e-faktura og rykkere.',
    ogDescription: 'Modtag al din virksomheds digitale post fra Virk og e-Boks direkte på email, og lad os håndtere dine bilag. Automatisk videresendelse til kolleger og revisor.',
    twitterDescription: 'Digital post fra Virk og e-Boks direkte på email — og bilagshåndtering med e-faktura i samme system.',
    themeColor: '#1A1A2E',

    // TODO: bekraeft supportadresse og ejerselskab for DigitalBox
    supportEmail,
    ownerLine: 'DigitalBox.dk er en service leveret af Sundahl ApS',
    copyrightName: 'DigitalBox',

    // TODO: afhaenger af om DigitalBox faar egen registrering i Digital Post.
    // Staar med hentposts vaerdier indtil det er afklaret, saa vejledningen er
    // korrekt frem for opdigtet — jf. samme TODO i backend/brand.py.
    digitalPost: {
        systemName: 'DigitalBox A/S',
        contactEmail: 'info@digitalbox.dk',
        contactPhone: '52404040',
        // DigitalBox A/S har sin egen Digital Post-registrering, og
        // dev.digitalbox.dk koerer paa selskabets eget certifikat.
        operatorName: 'DigitalBox A/S',
        operatorCvr: '45782956',
    },

    cloudFolder: 'DigitalBox',

    // TODO: skal DigitalBox saelge HentCVR/HentBilag-bundtet? Afventer beslutning.
    bundle: { ownProduct: 'DigitalBox', ownPrice: '49 kr' },

    // ── Forsidens indhold ────────────────────────────────────────────────────
    // Teksten bor her frem for i komponenten, saa den kan rettes uden at roere
    // layoutet. Alle paastande skal kunne holdes: systemet henter fra Virk og
    // e-Boks (MeMo) samt e-mail — ikke MIT.dk.
    landing: {
        nav: [
            { label: 'Om DigitalBox', href: '#om' },
            { label: 'Sådan virker det', href: '#saadan' },
            { label: 'FAQ', href: '#faq' },
            { label: 'Kontakt', href: '#kontakt' },
        ],

        hero: {
            // Ordet i {} understreges, som i designet
            overskrift: 'Lad {os} håndtere din post og dine bilag',
            broedtekst: 'Digital post fra Virk og e-Boks samlet ét sted — og e-faktura, '
                + 'rykkere via mail og SMS i samme system.',
            primaer: { label: 'Kom igang', href: '/register' },
            sekundaer: { label: 'Se hvad du får', href: '#om' },
        },

        om: {
            overskrift: 'Vi hjælper dig med at have {alt} samlet i ét system',
            broedtekst: 'Myndighedspost fra Virk og e-Boks, bilag fra dine leverandører og '
                + 'dine egne fakturaer lander samme sted. Ingen login på fem portaler, '
                + 'og ingen post der bliver væk i en indbakke ingen kigger i.',
            knap: { label: 'Kontakt os og hør nærmere', href: '#kontakt' },
        },

        saadan: {
            overskrift: 'Send videre til revisor og kolleger — automatisk',
            broedtekst: 'Sæt reglerne én gang. Så går fakturaer til bogholderen, '
                + 'myndighedspost til direktøren, og en kopi i dit eget arkiv i OneDrive, '
                + 'Google Drive eller Dropbox. Dine kolleger behøver ikke MitID.',
            knap: { label: 'Kontakt os og hør nærmere', href: '#kontakt' },
        },

        faq: {
            overskrift: 'Ofte stillede spørgsmål',
            punkter: [
                {
                    titel: 'Hvad kan jeg modtage i DigitalBox?',
                    svar: 'Digital post fra Virk og e-Boks, bilag sendt til din egen '
                        + 'bilags-mail, og filer du selv lægger op. Det hele samles i én '
                        + 'indbakke, du kan søge i og videresende fra.',
                },
                {
                    titel: 'Skal mine kolleger have MitID?',
                    svar: 'Nej. Du inviterer kolleger, revisor eller bogholder direkte i '
                        + 'systemet, og de får adgang uden MitID. Du bestemmer hvem der må '
                        + 'se hvilke selskaber.',
                },
                {
                    titel: 'Hvor bliver mine data gemt?',
                    svar: 'På EU-hostede servere med TLS-kryptering. Samtidig kan dine bilag '
                        + 'synkroniseres til dit eget OneDrive, Google Drive eller Dropbox, '
                        + 'så du altid selv har en kopi.',
                },
            ],
        },

        footer: {
            beskrivelse: 'samler din virksomheds digitale post og bilag ét sted. '
                + 'Post fra Virk og e-Boks, automatisk videresendelse til kolleger og revisor, '
                + 'e-faktura og rykkere — uden at nogen skal logge ind på flere portaler.',
            kolonner: [
                {
                    titel: 'Produkt',
                    links: [
                        { label: 'Om DigitalBox', href: '#om' },
                        { label: 'Sådan virker det', href: '#saadan' },
                        { label: 'Ofte stillede spørgsmål', href: '#faq' },
                    ],
                },
                {
                    titel: 'Konto',
                    links: [
                        { label: 'Log ind', href: '/login' },
                        { label: 'Opret konto', href: '/register' },
                        { label: 'Glemt adgangskode', href: '/forgot-password' },
                    ],
                },
                {
                    titel: 'Kontakt',
                    // TODO: telefonnummer og evt. adresse mangler for DigitalBox.
                    // Kun support-mailen staar her, saa der ikke opfindes kontaktveje
                    // kunder ikke kan bruge.
                    links: [
                        { label: supportEmail, href: `mailto:${supportEmail}` },
                    ],
                },
                // TODO: sociale profiler mangler. Designet viser Facebook, Instagram og
                // YouTube — de er udeladt indtil der findes rigtige profiler at linke til.
                // Doede ikoner er vaerre end ingen.
            ],
        },
    },
};
